<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            请假管理
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row> 
                    <el-button type="primary" :disabled="disabledLevel" @click="showModalLevel">请假</el-button>
                    <el-button type="success" :disabled="disabledReport" @click="showModalAdd">销假</el-button>
                    <!-- <el-button type="warning" @click="showLeaveRecord">请假记录</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                        <el-select
                            v-model="isReport"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="(item,i) in isReportValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click='rowClick' :height="th" border style="width: 100%;">

                        <el-table-column prop="elderlyName"  label="老人姓名"></el-table-column>
                        <el-table-column prop="startTime"  :formatter="formatterTime" label="开始时间"></el-table-column>
                        <el-table-column prop="endTime" :formatter="formatterTime" label="预计返回时间"> </el-table-column>
                        <el-table-column prop="reportTime" :formatter="formatterTime" label="销假时间"> </el-table-column>
                        <el-table-column prop="bailorName" label="委托人姓名"></el-table-column>
                        <el-table-column prop="bailorPhone" label="委托人电话"></el-table-column>
                        <el-table-column prop="remarks" label="请假原因"> </el-table-column>
                        <el-table-column prop="endTime" v-if="timeShow" label="是否超时">
                            <template slot-scope="scope">
                                <span v-if="dateSize(scope.row.endTime)" style="color:red">已超时</span>
                                <span v-if="!dateSize(scope.row.endTime)" style="color:#67C23A">未超时</span>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <Report ref="myReport" v-show="showModalReport" v-on:closeReport="showModalReport=false" v-on:getList="getList"></Report>
        <Leave ref="myLeave" v-show="showModalLeave" v-on:closeLeave="showModalLeave=false" v-on:getList="getList"></Leave>
        <!-- <Record ref="myRecord" v-show="showModalRecord" v-on:closeLeave="showModalRecord=false" v-on:getList="getList"></Record> -->
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Report from "./Report";
    import Leave from "./Leave";
    import {getStaffCode,getMenuButton} from "@/utils/auth";
    // import Record from './Record';

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalReport:false,
                showModalLeave:false,
                showModalRecord:false,
                disabledReport:true,
                disabledLevel:true,
                elderlyName:'',
                isReport:0,
                isReportValue:['未销假','已销假'],
                row:null,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                timeShow:false,
                reportTimeShow:true,
            }
        },
       components:{
            Report,Leave,
            // Record
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            dateSize(endTime){
                var oDate1 = new Date(endTime);
                var oDate2 = new Date();
                if(oDate1.getTime() < oDate2.getTime()){
                    return true; //第一个大
                } else {
                    return false; //第二个大
                }


            },
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(this.menuButtonList.indexOf("请假")!=-1){
                    this.disabledLevel =false;
                }
            },
            rowClick(row){
                this.row = row;
                if(this.menuButtonList.indexOf("销假")!=-1&&row.isReport==0){
                    this.disabledReport =false;
                }
            },
            showModalAdd:function(){
                this.$refs.myReport.init(this.row);
                this.showModalReport = !this.showModalReport;
            },
            showModalLevel(){
                this.$refs.myLeave.init();
                this.showModalLeave = !this.showModalLeave;
            },
            showLeaveRecord(){
                this.$refs.myRecord.init();
                this.showModalRecord=!this.showModalRecord;
            },
            closeReport:function(){
                this.showModalReport = !this.showModalReport;
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        isReport:this.isReport,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledReport=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        if(this.isReport==0){
                            this.timeShow = true;
                        }else{
                            this.timeShow = false;
                        }
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #218af3;
        color:#fff;
    }
</style>
